import { workoutLogStore } from "./localExecutionStore";

const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function fallbackUuidV4(cryptoObject) {
  const bytes = new Uint8Array(16);
  cryptoObject.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

export async function getOrCreateDeviceId({
  store = workoutLogStore,
  cryptoObject = typeof window === "undefined" ? null : window.crypto,
} = {}) {
  const existing = await store.getMeta("deviceId");
  if (UUID_V4.test(existing || "")) return existing;
  if (!cryptoObject) throw new Error("Secure randomness is unavailable.");
  const deviceId = typeof cryptoObject.randomUUID === "function"
    ? cryptoObject.randomUUID()
    : fallbackUuidV4(cryptoObject);
  if (!UUID_V4.test(deviceId)) throw new Error("Unable to create a UUID v4 device id.");
  await store.setMeta("deviceId", deviceId);
  return deviceId;
}

export async function requestPersistentWorkoutStorage({
  store = workoutLogStore,
  storage = typeof navigator === "undefined" ? null : navigator.storage,
} = {}) {
  if (await store.getMeta("persistRequested")) {
    return { requested: false, persisted: null };
  }
  let persisted = false;
  try {
    persisted = typeof storage?.persist === "function"
      ? Boolean(await storage.persist())
      : false;
  } finally {
    await store.setMeta("persistRequested", true);
  }
  return { requested: true, persisted };
}

export { UUID_V4 };
